export const getCurrentLanguage = (mode: 'short' | 'long' = 'short') => {
  let nextData = window.__NEXT_DATA__;
  if (nextData && (nextData as unknown as HTMLElement).nodeName === 'SCRIPT') {
    nextData = JSON.parse((nextData as unknown as HTMLElement).innerText);
  }
  if (nextData) {
    switch (mode) {
      case 'short':
        return nextData.props.pageProps.languageInfo.slug;
      case 'long':
        return nextData.props.pageProps.languageInfo.code.toLowerCase();
    }
  }
  if (window.currentLanguageObject) {
    switch (mode) {
      case 'short':
        return window.currentLanguageObject.shortLocale;
      case 'long':
        return window.currentLanguageObject.language;
    }
  }
  return 'en';
};
